import React, { useEffect, useState } from 'react'
import aos from 'aos'
import { ArrowRight, ArrowUp, BookOpen, Check, ChevronLeft, ChevronRight, Circle, Clock, Facebook, Instagram, Linkedin, Menu, Tv, Twitter, X } from 'react-feather'
import smarterbuyer from '../assets/images/portfolio/smarterbuyer.png'
import music from '../assets/images/portfolio/music.png'
import Betnomi from '../assets/images/portfolio/betnomi2.png'
import betno from '../assets/images/portfolio/betnomi2.mp4'
import nashimiuim from '../assets/images/portfolio/nashimiuimUser.png'
import dictionary from '../assets/images/portfolio/dictionary.png'
import TapTradie from '../assets/images/portfolio/Tap-A-Tradie.png'
import homeEats from '../assets/images/portfolio/homeEats.png'
import green from '../assets/images/portfolio/green.png'
import smata from '../assets/images/portfolio/smata.png'
import ydiy from '../assets/images/portfolio/ydiy.png'
import horseDeal from '../assets/images/portfolio/horseDeal.png'
import uptechHunt from '../assets/images/portfolio/uptechHunt.png'
import slatePlate from '../assets/images/portfolio/slatePlate.png'
import studySpot from '../assets/images/portfolio/studySpot.png'
import marriage from '../assets/images/portfolio/marriage.png'
import driverApp from '../assets/images/portfolio/driver.png'
import host from '../assets/images/portfolio/host.png'
import nftContactApp from '../assets/images/portfolio/nftContactApp.png'
import nftMintingWeb from '../assets/images/portfolio/nftMintingWeb.png'
import NFTart from '../assets/images/portfolio/NFTart.png'
import coinMill from '../assets/images/portfolio/coinMill.png'
import colorWeb from '../assets/images/portfolio/colorWeb.png'
import space from '../assets/images/portfolio/space.png'
import forceField from '../assets/images/portfolio/forceField.png'
import Charity from '../assets/images/portfolio/charity.png'
import vendor from '../assets/images/portfolio/vendor.png'
import BoostX from '../assets/images/portfolio/BoostX.png'
import Kurarob from '../assets/images/portfolio/Kurarob.png'












import Kinder from '../assets/images/portfolio/kinder.png'

// import dictionary from '../assets/images/portfolio/dictionary.png'

import { Link } from 'react-router-dom'


const Work = () => {


    const [activeId, setActiveId] = useState(1);
    console.log(activeId);

    const data = [
        {
            id: 1,
            pic: Betnomi,
            title: "Betnomi",
            category: "Web App",
            link: 'https://betnomi.com',
            desc:"The leading crypto gaming and betting site with a variety of sports to gamble on, tons of games from the industry’s top-rated providers, and all the slots you can ever imagine.",
            descDetail:"offer high-tech solutions and an outstanding player experience on your PCs and mobile devices that will exceed your expectations."
        },
        {
            id: 2,
            pic: homeEats,
            title: "Home Eats",
            category: "Mobile App",
            link: 'https://www.figma.com/file/x7zoQZNfmXsIEBZ2lw2s6T/Homeats-Consumer',
            desc: "Online ordering system that I am proposing here, greatly simplifies the ordering process for both the customer and the restaurant. System presents an interactive and up-to-date menu with all available options in an easy to use manner. Customer can choose one or more items to place an order which will land in the Cart.",
            descDetail:"Customer can view all the order details in the cart before checking out. At the end, customer gets order confirmation details. Once the order is placed it is entered in the database and retrieved in prettymuch real time. This allows Restaurant Employees to quickly go through the orders as they are received and process all orders efficiently and effectively with minimal delays and confusion.",
        },
        {
            id: 3,
            pic: BoostX,
            title: "BoostX Premium Launch Pad Technology",
            category: "Web App",
            link: 'https://www.figma.com/file/JDVVrItlNBFp4jUC5hGRSX/BoostX?node-id=32%3A2030',
            desc:"BoostX is a multi-chain launchpad enabling projects to raise capital, market effectively and ensure the safety of early investors.",
            descDetail:"BoostX provides its community with fair access to exclusive early-stage presale opportunities, allowing you to acquire highly-anticipated tokens before they hit the market; while simultaneously giving innovative projects the ability to crowdsource funding and build a strong and loyal community in the process.BoostX successfully facilitates the launches of multiple high quality blockchain projects."

        },
        
        {
            id: 4,
            pic: green,
            title: "Green Pal",
            category: "Web App",
            link: 'https://www.yourgreenpal.com/',
            desc: "GreenPal is hands-down the easiest way to book a local lawn care company for yard maintenance services at an affordable price. If you’re looking for same day lawn mowing or next day lawn cutting services you're at the right place.",
            descDetail:"GreenPal is the easiest way to book a lawn mowing services near me at the touch of a button without even having to make a phone call.",
        },
        {
            id: 5,
            pic: ydiy,
            title: "YDIY",
            category: "Web App",
            link: 'https://ydiy.com.au/',
            desc: "YDIY is a super special marketplace that includes superior professionals with an amazing experience. The customers have an array of services to choose from and get their job done",
            descDetail:"An exciting range of specific services that include, kitchen remodelling, pet care, health and wellbeing services, auto service requirements, party planning and many such listings in our inexhaustible inventory of services waiting to pamper you. All these and many more, right with a single click of yours to make sure that the help arrives at your doorstep at the exact time chosen by you.",
        },
        {
            id: 6,
            pic: Kinder,
            title: "Kinder Share-Baby Equipments",
            category: "Web App",
            link: 'https://www.kindershare.com/',
            desc: "Kindershare offers you that – a peer to peer marketplace for children’s equipment – connecting owners of baby equipment with those who need items on a short term basis.",
            descDetail:"Kindershare helps:Owners of baby equipment who want to declutter their house and earn money by renting out idle baby equipment.Parents or parents-to-be rent premium baby goods in their local area.Parents or parents-to-be test drive baby equipment for extended periods prior to purchase.",
        },
        {
            id: 7,
            pic: music,
            title: "Music As Code",
            category: "Web App",
            link: 'https://musicascode.com/',
            desc: "Music As Code is a streaming web app that helps budding artists/musicians upload songs and connect with fans.",
            descDetail:"They also wanted this app to serve as a go-to option that lets listeners stream music for free."

        },
        {
            id: 8,
            pic: TapTradie,
            title: "Tap-A-Tadie",
            category: "Web App",
            link: 'https://dev-tapatradie-react.netlify.app/',
            desc: "Tap a Tradie is a global marketplace connects in real time, consumers who need a job done with ‘Tradies’,, a network of qualified tradespeople, who have the time and skills needed to complete the requested online job request.",
            descDetail:"Tap a Tradie is an easy and effective way for consumers of services to outsource jobs to qualified tradies in their local area economies."
        },
        {
            id: 9,
            pic: smarterbuyer,
            title: "Smarter Buyer",
            category: "Web App",
            link: 'https://dev.smartbuyer.me/en/',
            desc: "Smart Buyer, is a known name in the e-commerce sphere. It is an identity specifically created to cater the needs of today’s customer.",
            descDetail:"It is the one-stop hub to get the latest and authentic mobiles prices of all upcoming and latest mobile phones of all different brands.",
        },

        {
            id: 10,
            pic: nashimiuim,
            title: "Nashimium",
            category: "PWA Website",
            link: 'https://nashimum.com/',
            desc: "Nashimium helps to find XNA Rates with other currencies",
        },
        {
            id: 11,
            pic: dictionary,
            title: "Dictionary Web App",
            category: "Web App",
            link: 'http://dictionaryish.com/',
            desc: "Dictionaryish is a platform where you can get the best quotes on life and quotes for all occasions. A vast collection of concepts, quotations, and the social sciences.",
        },
        {
            id: 12,
            pic: smata,
            title: "Smata",
            category: "Web App",
            link: 'https://www.smata.com/',
            desc: "SMATA is an ALL-IN-ONE CLOUD-BASED SOLUTION,INTEGRATING MANAGEMENT, COMMUNICATION & ACCOUNTING FUNCTIONS.",
        },
        {
            id: 13,
            pic: uptechHunt,
            title: "Uptech Hunt",
            category: "Web App",
            link: 'https://www.figma.com/file/h3Toc2uvGrmzIkrkge6Kht/Untitled?node-id=131%3A328',
            desc: "Upwork is a marketplace for freelancers in fields like writing, graphic design and web development. The site helps professionals find projects, communicate with clients and get paid. If you're a new freelancer, or working in a new field, you can rack up valuable experience without always having to pitch clients cold.",
        },
        {
            id: 14,
            pic: slatePlate,
            title: "Slate Plate",
            category: "Web App",
            link: 'https://www.figma.com/file/iYiubJ1RfcFjE1v9ps1d3a/slate-plate-Emoji-dropdown?node-id=0%3A1',
            desc: "Use our AI magic to create headlines for your Facebook ads based on your product or service's category. You can take these generated headlines, modify them to suit your cause best and run with them!",
        },
        {
            id: 14,
            pic: studySpot,
            title: "Study Spot",
            category: "Mobile App",
            link: 'https://www.figma.com/file/bxmjglliSnERxCJTSTF9wx/Studyspot-Mobile-App',
            desc: "The study spot project is basically for the new student to learn the lesson to complete the daily task basis. Every task has a specific time period when the student clicks the exercise then the task time start . ",
            descDetail:"After the time is over, give the result of the wrong or correct attempt at the task and show the result. It has also the option of next day task to remind the clock to activate the task.",
        },
        {
            id: 15,
            pic: marriage,
            title: "Marriage Bureau",
            category: "Web App",
            link: 'https://www.figma.com/file/STDN1uodvQlzafrQgXiYvl/website-marriage?node-id=0%3A1',
            desc: "This website specifically created to help singles find a suitable match for them through website and live consultant services. We are dedicated to the cause of bringing bachelors together on a platform where they can browse openly and safely about other suitors and find their ideal spouses online.",
        },
        {
            id: 16,
            pic: driverApp,
            title: "Online Driver App",
            category: "Mobile App",
            link: 'https://www.figma.com/file/4zMEAldTrpV4hReAgjN0Ud/Homeats-Driver-app-3?node-id=64%3A0',
            desc: "Its driver app for pick up food from the vendor and send to the consumer.",
        },
        {
            id: 17,
            pic: host,
            title: "Host App",
            category: "Mobile App",
            link: 'https://www.figma.com/file/FsYD3aAHulsVfzWCASqz8F/Homeats-Host-app-4',
            desc: "Host is a favorite app of food and travel lovers. From dinner parties to food tours to cooking classes, join our hand-selected locals in 130+ countries for immersive experiences you’ll always remember.",
        },
        {
            id: 18,
            pic: nftContactApp,
            title: "NFT Contact App",
            category: "Mobile App",
            link: 'https://www.figma.com/file/v2IyREn6a9WYxLV0kkXUQz/mobile-NFT-contact-app?node-id=0%3A1',
            desc: "NFT contact app is used for the small business contact app to secure business information. ",
        },
        {
            id: 19,
            pic: nftMintingWeb,
            title: "NFT Minting Web",
            category: "Web App",
            link: 'https://www.figma.com/file/SADYrBdI1TMPhaKMPhWDrV/Web3-Job-Website?node-id=345%3A50908',
            desc: "NFT Minting Web can help you navigate your way to utilizing this new emerging technology into your existing enterprise. With a world class consulting arm, we allow the development and integration of cryptocurrency and blockchain technology into companies and operations. ",
        },
        {
            id: 20,
            pic: NFTart,
            title: "NFT Art",
            category: "Mobile App",
            link: 'https://www.figma.com/file/rA2hXwo7Wc4FMOUDETUSqQ/crpotocurreny?node-id=0%3A1',
            desc: "Using NFT Art it is easy to electronically sign, manage and distribute all your contracts and documents safely, securely, anywhere, anytime- paperlessly. ",
        },
        {
            id: 21,
            pic: coinMill,
            title: "Coin Mill",
            category: "Web App",
            link: 'https://www.figma.com/file/schVrJSASZjnFzURdBlnd0/CM-Private-Round-NFT-Wallet',
            desc: "CoinMill is a multi-service solution for the projects to source funds as well as to promote their tokens within the wider audience on Coinex Smart Chain and reward token holders and liquidity providers through flexible stake2farm solutions.",
        },
        {
            id: 22,
            pic: colorWeb,
            title: "Color Inspiration Web",
            category: "Web App",
            link: 'https://www.figma.com/file/0tXEV0OjGCi3s4n3IOPz11/color-website',
            desc: "Create the perfect palette or get inspired by thousands of beautiful color schemes.",
        },
        {
            id: 23,
            pic: forceField,
            title: "Force Field",
            category: "Web App",
            link: 'https://www.figma.com/file/z3CZ2yGPkrCa8YjynIGOrN/freelancing-website',
            desc: "Upwork is a marketplace for freelancers in fields like writing, graphic design and web development. The site helps professionals find projects, communicate with clients and get paid. If you're a new freelancer, or working in a new field, you can rack up valuable experience without always having to pitch clients cold.",
        },
        {
            id: 24,
            pic: space,
            title: "Space Cadet",
            category: "Web App",
            link: 'https://www.figma.com/file/EFazCnZf2uHleBmtVEUyXu/Space-animation-website',
            desc: "Space Cadet is on a mission to fuel the growth and transformation of these industries by building cutting edge technology to bridge key gaps. We call this mission",
        },
        {
            id: 25,
            pic: Charity,
            title: "Charity App",
            category: "Mobile App",
            link: 'https://www.figma.com/file/IsLjtgy95p14GY7eCPqivZ/Homeats-Charity-app-5?node-id=2358%3A12295',
            desc: "In this app, Apart from the homeless people, there is the opportunity to help charities and watch where they are located on the map. If there is no financial opportunity, you can help in alternative ways, like with food, things, or others.",
        },
        {
            id: 26,
            pic: vendor,
            title: "Vendor App",
            category: "Mobile App",
            link: 'https://www.figma.com/file/MCYDzItOZY1AZyBzXLPwvi/Homeats-Vendor-1-app?node-id=4178%3A36271',
            desc: "Vendor app for the food vendor list which one select the consumer and give the order to the vendor by self-pick or delivery on home.",
        },
        {
            id: 27,
            pic: horseDeal,
            title: "Horse Deal 124",
            category: "Web App",
            link: 'https://www.horsedeal24.com/',
            desc: "Digital Platform expertise in arranging riding participation and state-of-the-art technology, we ensure that everyone - the rider, the owner and the horse - is happy together.",
            descDetail:"The search, communication, insurance and payment are all handled via our platform, making riding almost child's play - and not ending in bureaucra"
        },
        {
            id: 28,
            pic: Kurarob,
            title: "Kura Rob",
            category: "Web App",
            link: 'https://www.figma.com/file/EVXzp7jd6utABKzKrtHPSp/Kura-Rob?node-id=571%3A143',
            desc: "Kura is the first toilet designed to track your stool metabolites daily. ",
        },
        


    ];


    const [item, setItem] = useState(data);

    const filterItem = (categItem) => {
        const updatedItem = data.filter((curElem) => {
            return curElem.category === categItem
        });

        setItem(updatedItem);
    }
    useEffect(() => {
        aos.init({ duration: 2000 });
    }, [])

    return (
        <>


            {/* <!-- Start Portfolio Area --> */}
            <div className="rn-portfolio-area rn-section-gap section-separator" id="portfolio">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center">
                                <span className="subtitle">Visit my portfolio and keep your feedback</span>
                                <h2 className="title">My Portfolio</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">


                    <div className="row mt--45">
                        <div className="col-lg-12">

                            <div style={{ display: "flex", textAlign: "center", margin: "10px" }}>
                                <button type="button" className="btn btn-warning rn-btn" onClick={() => setItem(data)}>All</button>
                                <button type="button" className="btn btn-warning rn-btn" onClick={() => filterItem('Mobile App')}>Mobile App</button>
                                <button type="button" className="btn btn-warning rn-btn" onClick={() => filterItem('Web App')}>Web App</button>
                                <button type="button" className="btn btn-warning rn-btn" onClick={() => filterItem('PWA Website')}>PWA Website</button>

                            </div>
                        </div>
                    </div>
                    {/* <ul data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" data-aos-once="true" className="rn-nav-list" style={{display:"flex"}}>
                           
                    <li className="nav-item">
                                <a className="nav-link active" id="education-tab" data-toggle="tab" href="#education" role="tab" aria-controls="education" aria-selected="true">education</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="professional-tab" data-toggle="tab" href="#professional" role="tab" aria-controls="professional" aria-selected="false">professional
                                    Skills</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="experience-tab" data-toggle="tab" href="#experience" role="tab" aria-controls="experience" aria-selected="false">experience</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="interview-tab" data-toggle="tab" href="#interview" role="tab" aria-controls="interview" aria-selected="false">interview</a>
                            </li>
                        </ul> */}
                    {/* </div>
            </div> */}


                    <div className="row row--25 mt--10 mt_md--10 mt_sm--10">

                        {item.map((val, ind) => {
                            return (
                                <>
                                    <div onClick={() => setActiveId(ind)} data-aos="fade-up" data-aos-delay="300" data-aos-once="true" className="col-lg-3 col-xl-3 col-md-3 col-12 mt--50 mt_md--30 mt_sm--30">
                                        <Link to={`/#portfolio/${val.title}`}>

                                            <div className="rn-portfolio" data-toggle="modal" data-target="#exampleModalCenter">
                                                <div className="inner">
                                                    <div style={{height:"auto"}} className="thumbnail">

                                                        <img  src={val.pic} alt="Personal Portfolio Images" />

                                                    </div>
                                                    <div className="content">
                                                        <div className="category-info">
                                                            <div className="category-list">
                                                                <a> {val.category} </a>
                                                            </div>

                                                        </div>
                                                        <h4 className="title"><a>{val.title}<i className="feather-arrow-up-right"></i></a></h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </>
                            )
                        })}

                        {/* <!-- Start Single Portfolio --> */}

                        {/* <!-- End Single Portfolio --> */}





                    </div>
                </div>
            </div>
            {/* <!-- End portfolio Area --> */}


            {/* <!-- Modal Portfolio Body area Start --> */}
            <div className="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><X /></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row align-items-center">

                                <div className="col-lg-6">
                                    <div className="portfolio-popup-thumbnail">
                                        <div className="image">
                                            <img className="w-100" src={item[activeId]?.pic} alt="slide" />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="text-content">
                                        <h3>
                                            {item[activeId]?.title}
                                        </h3>
                                        <p className="mb--30">{item[activeId]?.desc}</p>
                                        <p>{item[activeId]?.descDetail}</p>
                                        <div className="button-group mt--20">
                                            {/* <a href="#" className="rn-btn thumbs-icon">
                                                <span>LIKE THIS</span>
                                                <i data-feather="thumbs-up"></i>
                                            </a> */}
                                            <a href={item[activeId]?.link} target="_blank" className="rn-btn">
                                                <span >VIEW PROJECT</span>
                                                <i data-feather="chevron-right"></i>
                                            </a>
                                        </div>

                                    </div>
                                    {/* <!-- End of .text-content --> */}
                                </div>
                            </div>
                            {/* <!-- End of .row Body--> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- End Modal Portfolio area --> */}
        </>
    )
}

export default Work